// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__eaIn6","productName":"Table_productName__3tbvg"};